module.exports = __webpack_public_path__ + "img/adware.41b284dd.png";